module.exports = __webpack_public_path__ + "img/licenzaPersonale.5e0684be.jpeg";